import React, { Suspense, Component } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import ErrorBoundary from './common/components/error-handler/error-handler.component';
import { ROUTES, META_TAGS } from './common/constants/app.constants';
import { setMetaTags } from './common/utils/app.utils';
import Quotation from './dedicated/components/quotation/Quotation';
import Thanks from './dedicated/components/thanks/Thanks';
import CheckFeasibility from 'home/view/check-feasibility';
import CheckFeasibilityAOI from 'home/view/check-feasibility-aoi';
import SingleSiteUpgrade from './home/view/upgrade-order/single-site';
import PlanPage from './home/components/functional/plan-page/plan-page.component';
import appConfig from '../src/config/config';
import AehThanks from './dedicated/components/cancelOrder/aeh-thankyou';
import Summary from './dedicated/components/summary/summary';
import BulkFeasibilityComponent from 'home/view/manage-feasibility/pages/BulkFeasibilityComponent';
import DedicatedOrderSummary from 'home/view/manage-feasibility/pages/DedicatedOrderSummary';
import BulkFeasibilityComponentAOI from 'home/view/manage-feasibility/pages/BulkFeasibilityComponentAOI';
import DedicatedOrderSummaryAOI from 'home/view/manage-feasibility/pages/DedicatedOrderSummaryAOI';
import TrackOrderAOI from 'home/view/manage-feasibility/pages/TrackOrderAOI';
import TrackOrder from './dedicated/components/TrackOrder/TrackOrder';
import ConfigurePlanPricing from './dedicated/components/plan-and-configuration/configure-plan-pricing';
import ConfigurePlanPricingAOI from './dedicated/components/plan-and-configuration-aoi/configure-plan-pricing';
import GENERIC_ERROR from 'common/components/GenericErrorPage/genricError';
import ProtectedRoutes from 'common/components/ProtectedRoutes';
import failure from './dedicated/components/failure/Failure';
import success from './dedicated/components/success/Success';
import { RateCard } from 'rateCard/rateCard';
import LoginComponent from 'featureLib/AppointmentEdl/LoginComponent';
import UnauthView from 'home/view/check-feasibility/unauth-view';
import { PurchaseOrder, OrderDetails, InstallationDetails, MultiSelectDropDownWithSearch } from 'featureLib';
import { AppContext } from 'App';
import AppointmentEdl from 'featureLib/AppointmentEdl';
import ConfirmInstallationComponent from 'featureLib/ConfirmInstallationComponent';

export function LazyLoad(Component, additionalProps) {
  return (props) => (
    <ErrorBoundary>
      <Suspense fallback={<div>Loading...</div>}>
        <Component {...props} {...additionalProps} />
      </Suspense>
    </ErrorBoundary>
  );
}

class Routes extends Component {
  static contextType = AppContext;

  componentDidMount() {
    this.updateTagsOnPathChange();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.updateTagsOnPathChange();

      this.props.toggelNotification();
    }
  }

  updateTagsOnPathChange() {
    let currentRoute = this.props.location.pathname.replace(/\/$/, '');
    switch (currentRoute) {
      case ROUTES.AOI.DEDICATED_HOME:
        setMetaTags(META_TAGS.AOI_CHECK_FEASIBLITY);
        break;
      case ROUTES.AOI.DEDICATED_BULK_FEASIBILITY:
        setMetaTags(META_TAGS.AOI_CHECK_FEASIBLITY);
        break;
      case ROUTES.AOI.DEDICATED_ORDER_SUMMARY:
        setMetaTags(META_TAGS.AOI_CHECK_FEASIBLITY);
        break;
      case ROUTES.AOI.TRACK_ORDER_AOI:
        setMetaTags(META_TAGS.AOI_CHECK_FEASIBLITY);
        break;
      case ROUTES.AOI.MULTI_SITE_PLAN_PRICING:
        setMetaTags(META_TAGS.AOI_CHECK_FEASIBLITY);
        break;
      case ROUTES.B2B_HOME:
        setMetaTags(META_TAGS.B2B_HOME);
        break;
      case ROUTES.B2B_CHECK_FEASIBILITY:
        setMetaTags(META_TAGS.B2B_CHECK_FEASIBILITY);
        break;
      case ROUTES.B2B_CHOOSE_PLAN:
        setMetaTags(META_TAGS.B2B_CHOOSE_PLAN);
        break;
      case ROUTES.B2B_SUMMARY:
        setMetaTags(META_TAGS.B2B_SUMMARY);
        break;

      case ROUTES.B2B_THANK_YOU:
        setMetaTags(META_TAGS.B2B_THANK_YOU);
        break;
      default:
        setMetaTags(META_TAGS.B2B_HOME);
    }
    if (!currentRoute || currentRoute == ROUTES.B2B_HOME || currentRoute === '' || currentRoute == ROUTES.DEDICATED_URL) {
      this?.context?.setIsAuthJourney?.(false);
      sessionStorage?.setItem('flow', 'unAuthFlow');
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <Switch>
          {/* <Route
            path="/"
            exact
            component={() => {
              window.location = appConfig.dedicatedhomePageUrl;
              return null;
            }}
          /> */}
          <Route
            path={ROUTES.DEDICATED_HOME}
            render={(props) => {
              return <CheckFeasibility {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />;
            }}
          ></Route>
          <Route
            path={ROUTES.DEDICATED_CHECK_FEASIBILITY}
            render={(props) => {
              return <CheckFeasibility {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />;
            }}
          ></Route>

          <Route exact path={ROUTES.UNAUTH_HOME} component={LazyLoad(UnauthView, { ...this.props })}></Route>

          <Route path={ROUTES.UPGRADE_ORDER} component={LazyLoad(SingleSiteUpgrade, { ...this.props })} />
          <Route path={ROUTES.DEDICATED_QUOTATION} component={LazyLoad(Quotation)}></Route>
          <Route path={ROUTES.DEDICATED_CANCEL} render={(props) => <AehThanks {...props} isUnAuthJourney={this.props.isUnAuthJourney} />}></Route>
          <Route path={ROUTES.DEDICATED_THANK_YOU} render={(props) => <Thanks {...props} isUnAuthJourney={this.props.isUnAuthJourney} />}></Route>
          <Route
            exact
            path={ROUTES.DEDICATED_CHOOSE_PLAN}
            render={(props) => <PlanPage {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />}
          ></Route>
          <Route path={ROUTES.DEDICATED_SUMMARY} render={(props) => <Summary {...props} isUnAuthJourney={this.props.isUnAuthJourney} />}></Route>
          <Route path={ROUTES.CONFIRM_INSTALLATION} render={(props) => <ConfirmInstallationComponent {...props} isUnAuthJourney={this.props.isUnAuthJourney} />}></Route>
          <Route path={ROUTES.B2B_FAILURE} component={failure}></Route>
          <Route path={ROUTES.B2B_SUCCESS} component={success}></Route>
          <Route
            exact
            path={ROUTES.DEDICATED_BULK_FEASIBILITY}
            render={(props) => <BulkFeasibilityComponent {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />}
          ></Route>
          <Route
            exact
            path={ROUTES.MULTI_SITE_PLAN_PRICING}
            render={(props) => <ConfigurePlanPricing {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />}
          ></Route>
          <Route
            exact
            path={ROUTES.DEDICATED_ORDER_SUMMARY}
            render={(props) => <DedicatedOrderSummary {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />}
          ></Route>

          <Route path={ROUTES.TRACK_ORDER} component={TrackOrder}></Route>
          <Route
            exact
            path={ROUTES.ERROR_PAGE}
            render={(props) => <GENERIC_ERROR {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />}
          ></Route>
          <Route path={ROUTES.RATE_CARD} component={LazyLoad(RateCard)}></Route>

          {/** AOI Routes */}

          <Route
            path={ROUTES.AOI.DEDICATED_HOME}
            render={(props) => {
              return <CheckFeasibilityAOI {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />;
            }}
          ></Route>

          <Route
            exact
            path={ROUTES.AOI.DEDICATED_BULK_FEASIBILITY}
            render={(props) => {
              return <BulkFeasibilityComponentAOI {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />;
            }}
          ></Route>
          <Route
            exact
            path={ROUTES.AOI.MULTI_SITE_PLAN_PRICING}
            render={(props) => <ConfigurePlanPricingAOI {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />}
          ></Route>
          <Route
            exact
            path={ROUTES.AOI.DEDICATED_ORDER_SUMMARY}
            render={(props) => <DedicatedOrderSummaryAOI {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />}
          ></Route>
          <Route
            exact
            path={ROUTES.AOI.TRACK_ORDER_AOI}
            render={(props) => <TrackOrderAOI {...props} isdedicatedJourney={this.props.isdedicatedJourney} isUnAuthJourney={this.props.isUnAuthJourney} />}
          ></Route>

          <Route path={ROUTES.EXPRESS_DELIVERY_PAGE_LOGIN} component={LazyLoad(LoginComponent)}></Route>
          <Route path={ROUTES.EXPRESS_DELIVERY_PAGE_ORDER} component={LazyLoad(AppointmentEdl)}></Route>
          {/**
           * FEATURE LIB - COMPONENTS ROUTE
           * TARGET - DEV ENV
           */}

          <ProtectedRoutes exact path={ROUTES.FEATURE_LIB.PURCHASE_ORDER} comp={LazyLoad(PurchaseOrder, { ...this.props })} condition={appConfig.env === 'DEV'} />
          <ProtectedRoutes exact path={ROUTES.FEATURE_LIB.ORDER_DETAILS} comp={LazyLoad(OrderDetails, { ...this.props })} condition={appConfig.env === 'DEV'} />
          <ProtectedRoutes exact path={ROUTES.FEATURE_LIB.INSTALLATION_DETAILS} comp={LazyLoad(InstallationDetails, { ...this.props })} condition={appConfig.env === 'DEV'} />
          <ProtectedRoutes exact path={ROUTES.FEATURE_LIB.MULTI_SELECT} comp={LazyLoad(MultiSelectDropDownWithSearch, { ...this.props })} condition={appConfig.env === 'DEV'} />
        </Switch>
      </ErrorBoundary>
    );
  }
}

export default withRouter(Routes);
